import parseJwt from "../../util/JwtParser";
import { AuthenticationURL } from "../Services";

export function isLogin() {
    if (localStorage.getItem("accessToken")) {
        var expiredAccessTime = parseJwt(localStorage["accessToken"])["exp"];
        var now = Math.floor(Date.now() / 1000);
        if (expiredAccessTime > now) return true;
    }
    return false;
}

export const RegisterAPI = AuthenticationURL + 'api/register'